<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoadingTask"
      :can-cancel="false"
    ></b-loading>
    <DocumentsModal
      v-if="isDocumentModalVisible"
      :isDocumentModalVisible="isDocumentModalVisible"
      @close="closeDocumentModal"
    />
    <UsedInstrumentationsModal
      v-if="isUsedInstrumentationModalVisible"
      @close="closeUsedInstrumentationModal"
      @addInstrument="addInstrument"
      ref="usedInstrumentationsRef"
    />
    <AddInstrumentationsModal
      v-if="isInstrumentationModalVisible"
      @close="closeInstrumentationModal"
      @save="onSaveInstrumentationModal"
    />
    <ExternalData
      v-if="isExternalDataVisible"
      :task="currentTask"
      :job="currentJob"
      :taskMode="true"
      :key="currentTask._id"
      @close="onCloseExternalData"
    />
    <TaskHeader :type="type">
      <template v-slot:breadcrumbs>
        <TasksBreadcrumb :isTask="true" :tool="type" />
      </template>
      <template v-slot:leadmanlabel>
        <div
          v-if="currentTask.requiredSigning && type === 'inspector'"
          class="leadman-label"
        >
          {{ $t('shared.leadman_sign_off_required') }}
        </div>
      </template>
      <template v-slot:instrumentationloglabel>
        <div
          @click="showInstrumentationModal"
          v-if="type === 'inspector'"
          class="leadman-label"
        >
          <img
            class="img-icon"
            :class="{ 'flashing-icon': currentTask.requireInstrumentLog }"
            src="/img/diagram_icon.png"
          />
        </div>
      </template>
      <template v-slot:dropdown-buttons>
        <template v-if="type === 'inspector'">
          <b-dropdown-item aria-role="listitem">
            <b-button
              class="button"
              icon-left="file-document-arrow-right"
              @click="showDocumentsModal"
              :disabled="!canMutateTask"
            >
              {{ $t('shared.documents') }}
            </b-button>
          </b-dropdown-item>

          <b-dropdown-item aria-role="listitem">
            <b-button
              class="button"
              @click="showUsedInstrumentationModal"
              :disabled="!canMutateTask"
            >
              <img
                src="/img/diagram_icon.png"
                style="width: 24px; height: 24px"
              />
              {{ $t(`${TRANSLATION_ROOT}.manageMte`) }}
            </b-button>
          </b-dropdown-item>

          <b-dropdown-item
            aria-role="listitem"
            v-if="currentTask.mtes && currentTask.mtes.length > 0"
          >
            <b-button class="button" @click="onShowManageMTE"
              >[OLD] {{ $t(`${TRANSLATION_ROOT}.manageMte`) }}
            </b-button>
          </b-dropdown-item>

          <b-dropdown-item aria-role="listitem">
            <b-button
              class="button"
              @click="onShowRepairAssessment"
              :disabled="!canMutateTask"
              >{{ $t(`${TRANSLATION_ROOT}.repairAssessment`) }}</b-button
            >
          </b-dropdown-item>

          <b-dropdown-item aria-role="listitem" v-if="taskType === 'diagram'">
            <b-upload
              v-model="fileAccuScan"
              class="button"
              :disabled="!canMutateTask"
            >
              <span class="flex">
                <b-icon class="file-icon" icon="gauge"></b-icon>
                <span>{{ $t(`${TRANSLATION_ROOT}.importAccuScan`) }}</span>
              </span>
            </b-upload>
          </b-dropdown-item>

          <b-dropdown-item aria-role="listitem" v-if="taskType === 'diagram'">
            <b-upload
              v-model="fileLaserScan"
              class="button"
              :disabled="!canMutateTask"
            >
              <span class="flex">
                <img class="tool-image-icon" src="/img/acc_scan.png" />
                <span>{{ $t(`${TRANSLATION_ROOT}.importLaserscan`) }}</span>
              </span>
            </b-upload>
          </b-dropdown-item>

          <b-dropdown-item aria-role="listitem">
            <b-button
              class="button"
              @click="onShowExternalData()"
              :disabled="!canMutateTask"
            >
              <span class="flex">
                <b-icon class="file-icon" icon="paperclip"></b-icon>
                <span> {{ $t('shared.upload_attachments') }}</span>
              </span>
            </b-button>
          </b-dropdown-item>
        </template>
      </template>

      <template v-slot:buttons>
        <template v-if="type === 'inspector'">
          <!-- <b-checkbox-button
            v-if="currentTask.requiredSigning"
            class="border-left"
            v-model="checkboxLeadman"
            type="is-success"
          >
            <b-icon icon="check"></b-icon>
            <span>Leadman</span>
          </b-checkbox-button> -->
          <b-tooltip
            :label="
              isSignoffDisabled ? $t('shared.leadman_sign_off_required') : ''
            "
            type="is-light"
            position="is-left"
          >
            <b-button
              :disabled="isSignoffDisabled || !canMutateTask"
              class="button"
              type="is-info"
              @click="onSave"
              >{{ $t(`${TRANSLATION_ROOT}.signOff`) }}</b-button
            >
          </b-tooltip>
        </template>

        <template v-else>
          <b-dropdown :close-on-click="false">
            <template #trigger="{ active }">
              <b-button
                style="margin-top: 7px"
                label="Options"
                type="is-primary"
                :disabled="!canMutateTask"
                :icon-right="active ? 'menu-up' : 'menu-down'"
              />
            </template>

            <b-dropdown-item aria-role="listitem">
              <b-checkbox
                :disabled="!canMutateTask"
                v-model="requiredSigning"
                >{{ $t('shared.require_leadman_signing') }}</b-checkbox
              >
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem">
              <b-checkbox
                :disabled="!canMutateTask"
                v-model="requireInstrumentLog"
                >Require intrumentation log</b-checkbox
              >
            </b-dropdown-item>
          </b-dropdown>

          <b-button
            v-if="taskType === 'instruction'"
            icon-left="download"
            type="is-info"
            @click="exportInstructionsData"
          >
            {{ $t('shared.download') }}
          </b-button>

          <b-button
            v-if="taskType === 'diagram'"
            icon-left="download"
            type="is-info"
            @click="exportDiagramData"
          >
            {{ $t('shared.download') }}
          </b-button>

          <b-button
            v-if="taskType === 'instruction'"
            icon-left="upload"
            type="is-info"
            :disabled="!canMutateTask"
            @click="$refs.importAdd.click()"
            >{{ $t('shared.upload') }}</b-button
          >

          <input
            ref="importAdd"
            type="file"
            class="hidden"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
            @change="handleInstructionImportAdd"
          />

          <b-button
            v-if="taskType === 'diagram'"
            icon-left="upload"
            type="is-info"
            :disabled="!canMutateTask"
            @click="$refs.importAddDiagram.click()"
            >{{ $t('shared.upload') }}</b-button
          >

          <input
            ref="importAddDiagram"
            type="file"
            class="hidden"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
            @change="handleDiagramImportAdd"
          />

          <b-button
            :disabled="!canMutateTask"
            class="border-left button"
            type="is-danger"
            @click="onDelete"
            >{{ $t(`${TRANSLATION_ROOT}.delete`) }}</b-button
          >

          <b-button class="button" @click="onCancel">{{
            $t(`${TRANSLATION_ROOT}.back`)
          }}</b-button>

          <b-button
            class="button"
            type="is-info"
            :disabled="!canMutateTask"
            @click="onSave"
            >{{ $t(`${TRANSLATION_ROOT}.save`) }}</b-button
          >
        </template>
      </template>
    </TaskHeader>
    <div v-if="!isLoadingTask">
      <slot></slot>
    </div>
    <div v-else>
      <div
        v-if="taskType !== 'diagram' && taskQuestions.length === 0"
        class="instructions-skeleton"
      >
        <b-skeleton
          v-for="index in 8"
          :key="index"
          width="100%"
          height="70px"
          :animated="true"
        ></b-skeleton>
      </div>
      <div
        v-if="taskType === 'diagram' && taskBubbles.length === 0"
        class="diagram-skeleton"
      >
        <div style="width: 10%; height: 100%">
          <b-skeleton width="100%" height="87vh" :animated="true"></b-skeleton>
        </div>
        <div style="width: 74%; height: 100%">
          <b-skeleton width="100%" height="87vh" :animated="true"></b-skeleton>
        </div>
        <div style="width: 16%; height: 100%">
          <b-skeleton width="100%" height="87vh" :animated="true"></b-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { GET_CURRENT_JOB } from '../../store/jobs/getters/getterTypes';
import {
  GET_CURRENT_FOLDER,
  GET_CURRENT_TASK,
} from '../../store/tasks/getters/getterTypes';
import { GET_TASK_BUBBLES } from '../../store/bubbles/getters/getterTypes';
import { GET_TASK_QUESTIONS } from '../../store/questions/getters/getterTypes';
// import { GET_LOADING_STATE } from '../../store/loading/getters/getterTypes';
import { LINK_INSTRUMENTATION_TASK } from '../../store/instrumentations/actions/actionTypes';

import InstructionsMixin from '../../mixins/InstructionMixin';
import DiagramMixin from '../../mixins/DiagramMixin';

import {
  DELETE_TASK,
  SIGN_LEADMAN,
} from '../../store/tasks/actions/actionTypes';

import TaskHeader from './TaskHeader';
import Breadcrumb from './Breadcrumb';
import FoldersManagerMixin from '../../mixins/FoldersManagerMixin';
import OfflineMixin from '../../mixins/OfflineMixin';

import DocumentsModal from './DocumentsModal';
import AddInstrumentationsModal from './Instrumentations/AddInstrumentationsModal';
import UsedInstrumentationsModal from './Instrumentations/UsedInstrumentationsModal';

import ExternalData from './ExternalData';
import WORK_STATUS_CODE from '../../constants/workStatusCode';
import TasksBreadcrumb from './TasksBreadcrumb';

const TRANSLATION_ROOT = 'task_view';

export default {
  components: {
    TaskHeader,
    Breadcrumb,
    TasksBreadcrumb,
    DocumentsModal,
    AddInstrumentationsModal,
    UsedInstrumentationsModal,
    ExternalData,
  },
  mixins: [FoldersManagerMixin, OfflineMixin, InstructionsMixin, DiagramMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      TRANSLATION_ROOT,
      checkboxLeadman: false,
      requiredSigning: false,
      requireInstrumentLog: false,
      accuScan: null,
      fileAccuScan: null,
      fileLaserScan: null,
      isLoadingTask: false,
      isDocumentModalVisible: false,
      isInstrumentationModalVisible: false,
      isExternalDataVisible: false,
      isUsedInstrumentationModalVisible: false,
    };
  },
  computed: {
    isLeadman() {
      return this.$store.getters['auth/isLeadman'];
    },
    isInspector() {
      return this.$route.name === 'inspector-template';
    },
    taskQuestions() {
      return this.$store.getters[GET_TASK_QUESTIONS];
    },
    taskBubbles() {
      return this.$store.getters[GET_TASK_BUBBLES];
    },
    // This is cumming from the mixin module
    // isLoading() {
    //   return this.$store.getters[GET_LOADING_STATE];
    // },
    currentJob() {
      return this.$store.getters[GET_CURRENT_JOB];
    },
    currentTask() {
      return this.$store.getters[GET_CURRENT_TASK];
    },
    user() {
      return this.$store.state.currentUser;
    },
    currentFolder() {
      return this.$store.getters[GET_CURRENT_FOLDER];
    },
    taskCompleted() {
      return parseInt(this.currentTask.workStatusCode, 10) === 2;
    },
    canMutateTask() {
      return this.$store.getters.canMutateTask(this.currentJob, this.type, {
        isCompleted: this.taskCompleted,
        isReadOnly: this.readOnly,
      });
    },
    breadcrumbs() {
      const breadcrumbs = [
        {
          label: this.currentJob.title,
          to: `/view/${this.type}/${this.currentJob._id}`,
          subLabels: [
            this.currentJob.frameType ? this.currentJob.frameType[0].text : '',
            ...this.computeTypeSubLevels(),
          ],
        },
      ];

      if (this.currentTask.folderId && this.currentFolder.taskName) {
        breadcrumbs.push({
          label: this.currentFolder.taskName,
          to: `/view/${this.type}/${this.currentJob._id}/folder/${this.currentTask.folderId}`,
        });
      }

      breadcrumbs.push({
        label: this.currentTask.taskName,
        to: `/view/${this.type}/${this.currentJob._id}/${this.currentTask._id}`,
      });
      return breadcrumbs;
    },
    taskType() {
      return this.currentTask?.taskType || null;
    },
    isSignoffDisabled() {
      if (
        parseInt(this.currentTask.workStatusCode, 10) ===
        parseInt(WORK_STATUS_CODE.SIGN_OFF, 10)
      ) {
        return true;
      }
      const { requiredSigning } = this.currentTask;
      if (!requiredSigning) return false;

      // Allow sign-off if user has the leadman_signoff permission or is a power admin
      if (this.$store.getters.isPowerAdmin) return false;
      if (this.$store.getters.hasPermission('inspector.leadman_signoff'))
        return false;

      return true;
    },
  },
  watch: {
    fileAccuScan(newVal) {
      if (!newVal) return;
      this.processCSVFile(
        newVal,
        'accuScanImport',
        () => (this.fileAccuScan = null)
      );
    },
    fileLaserScan(newVal) {
      if (!newVal) return;
      this.processCSVFile(
        newVal,
        'laserScanImport',
        () => (this.fileLaserScan = null)
      );
    },
    async requiredSigning(newValue) {
      this.currentTask.requiredSigning = newValue;
      await this.$store.dispatch('updateTask', this.currentTask);
    },

    requireInstrumentLog(newValue) {
      this.currentTask.requireInstrumentLog = newValue;
      this.$store.dispatch('updateTask', this.currentTask);
    },

    async checkboxLeadman(newValue) {
      await this.$store.dispatch(SIGN_LEADMAN, {
        isSign: newValue,
        id: this.currentTask._id,
      });
    },
  },
  created() {
    this.requiredSigning = this.currentTask.requiredSigning
      ? this.currentTask.requiredSigning
      : false;

    this.requireInstrumentLog = this.currentTask.requireInstrumentLog
      ? this.currentTask.requireInstrumentLog
      : false;

    this.checkboxLeadman = this.currentTask.workStatusCode === '2';
  },
  methods: {
    addInstrument() {
      this.showInstrumentationModal();
    },
    showUsedInstrumentationModal() {
      this.isUsedInstrumentationModalVisible = true;
    },
    closeUsedInstrumentationModal() {
      this.isUsedInstrumentationModalVisible = false;
    },

    showInstrumentationModal() {
      this.isInstrumentationModalVisible = true;
    },
    closeInstrumentationModal() {
      this.isInstrumentationModalVisible = false;
    },
    async onSaveInstrumentationModal(selectedInstrumentations) {
      this.closeInstrumentationModal();
      await this.$store.dispatch(LINK_INSTRUMENTATION_TASK, {
        instrumentations: selectedInstrumentations,
        taskId: this.currentTask._id,
      });

      if (
        this.isUsedInstrumentationModalVisible &&
        this.$refs.usedInstrumentationsRef
      ) {
        this.$refs.usedInstrumentationsRef.refreshData();
      }
    },
    showDocumentsModal() {
      this.isDocumentModalVisible = true;
    },
    closeDocumentModal() {
      this.isDocumentModalVisible = false;
    },
    processCSVFile(file, eventEmit, callbackOnSuccess) {
      if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
        this.$buefy.snackbar.open({
          message: 'Please upload only .csv files',
          type: 'is-danger',
          position: 'is-top',
          duration: 5000,
        });
        return; // Stop processing any further
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        let tableData = [];
        if (eventEmit === 'accuScanImport') {
          tableData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            raw: false,
          });
        } else {
          tableData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
        }
        this.$emit(eventEmit, tableData);
        callbackOnSuccess();
      };
      reader.onerror = (err) => {
        console.error('Error reading file:', err);
      };

      reader.readAsArrayBuffer(file);
    },

    onSave() {
      if (!this.canMutateTask) return;
      this.$emit('onSave', this.currentTask, this.onCancel);
    },
    onSignOff() {
      this.$emit('onSignOff');
    },
    gotoPrevStep() {
      this.isLoadingTask = true;
      const { id } = this.$route.params;
      const routeName = `${this.type}-tasks`; // e.g: 'editor-tasks'
      const { token, from, package: packageId } = this.$route.query || {};

      if (from === 'wi') {
        const query = {
          ...(packageId ? { package: packageId } : {}),
          ...(token ? { token } : {}),
        };
        return this.$router.push({
          name: `${this.type}-work-instructions`,
          params: { id },
          query,
        });
      }
      if (this.currentTask.folderId && !this.currentFolder.folderId) {
        const path = `/view/${this.type}/${this.currentJob._id}/folder/${this.currentTask.folderId}`;
        const query = token ? { token } : undefined;
        return this.$router.push({ path, query });
      }

      if (this.currentFolder.folderId) {
        const path = `/view/${this.type}/${id}/folder/${this.currentFolder.folderId}/${this.currentFolder._id}`;
        const query = token ? { token } : undefined;
        return this.$router.push({ path, query });
      }

      const params = { id };
      const query = token ? { token } : undefined;
      this.$router.push({ name: routeName, params, query });
    },

    async onDelete() {
      if (!this.canMutateTask) return;
      if (await this.preventOfflineAction()) {
        return;
      }

      this.$buefy.dialog.confirm({
        title: 'Deleting task',
        message: this.$t(`${TRANSLATION_ROOT}.deleteConfirmation`, {
          taskTitle: this.currentTask.title,
        }),
        confirmText: this.$t(`${TRANSLATION_ROOT}.deleteTask`),
        cancelText: this.$t(`${TRANSLATION_ROOT}.cancel`),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch(DELETE_TASK, this.currentTask._id);
          this.onCancel();
        },
      });
    },
    onCancel() {
      if (this.currentTask.folderId) {
        this.$router.push(
          `/view/${this.type}/${this.currentJob._id}/folder/${this.currentTask.folderId}`
        );
        return;
      }
      this.$router.push(`/view/${this.type}/${this.currentJob._id}`);
    },
    onShowManageMTE() {
      this.$emit('onShowManageMTE');
    },
    onShowRepairAssessment() {
      this.$emit('onShowRepairAssessment');
    },
    hideRepairAssessment() {
      this.repairAssessmentVisible = false;
    },
    onShowExternalData() {
      this.isExternalDataVisible = true;
    },
    async onCloseExternalData() {
      this.isExternalDataVisible = false;
    },
    computeTypeSubLevels() {
      if (this.type === 'editor') {
        return [
          this.currentJob.documentNumber,
          this.currentJob.revision,
          this.currentJob.documentNumber,
        ];
      }

      return [
        this.currentJob.projectInfoText,
        this.currentJob.customerInfoText,
        this.currentJob.workOrderNumber,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.b-tooltips {
  .b-tooltip:not(:last-child) {
    margin-right: 0.5em;
  }
  .b-tooltip {
    margin-bottom: 0.5em;
  }
}
.diagram-space {
  widows: 80%;
}

.flex {
  display: flex;
  align-items: center;
}

.tool-image-icon {
  height: 24px;
  width: 24px;
  margin-left: calc(-0.375em - 1px);
  margin-right: 0.1875em;
}

.diagram-skeleton {
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 10px;
}

.instructions-skeleton {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.back-button {
  display: inline-flex;
  width: 80px;
  height: 100%;
  cursor: pointer;
  img {
    width: 25px;
    margin: auto;
    &:hover {
      filter: brightness(0%);
    }
  }
}

.dropdown-import {
  margin-top: 14px;
}
.leadman-label {
  font-size: medium;
  font-style: italic;
  font-weight: bold;
  color: red;
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 10px;
}

.img-icon {
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.flashing-icon {
  animation: slide-in-out 1s linear infinite;
  filter: brightness(0) saturate(100%) invert(18%) sepia(94%) saturate(7485%)
    hue-rotate(0deg);
}

@keyframes slide-in-out {
  0%,
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
  50% {
    transform: translateY(
      7.5%
    ); /* Adjust this value for greater or less movement */
    opacity: 0.2;
  }
}
</style>
